import styled from '@emotion/styled/macro'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'

import { Flex } from '../Layout'
import { ActivePageIndicator } from '../MenuLink'
import { zIndex } from '../css'
import { media } from '../Responsive'

export const Header = styled(Flex)`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  height: ${(props) => props.menuHeight}px;

  padding: 0 8px;

  z-index: ${zIndex.header};

  ${media.mobile} {
    height: 48px;
    padding: 0 16px;
    flex-direction: row;
  }

  /* We need this set, otherwise body content will appear underneath as we scroll */
  background-color: ${colors.HEADER};

  ${ActivePageIndicator} {
    bottom: ${isCanlan
      ? -17
      : -16}px; /* The indicator is misaligned here for some reason */
  }

  .nav {
    margin-left: 24px;

    .page-menu-nav-link {
      transition: 0.1s ease-in-out;
    }

    .page-menu-nav-link.active {
      /* color: ${colors.DEFAULT_FLAIR}; */
      color: ${colors.WHITE};
      font-weight: 600;
    }

    opacity: 1;

    transition: opacity 0.2s ease-in-out;

    &.search-active {
      opacity: 0;
      pointer-events: none;
    }
  }

  .main-nav-search-container {
    ${media.mobile} {
      margin-left: 0;
      flex: 1;

      &.is-filter-active,
      &.is-filter-active-canlan {
        width: 100%;
      }
    }
  }

  .main-nav-search-input {
    ${media.mobile} {
      /* Mobile-specific overrides if needed */
    }
  }

  .search-filter-container {
    ${media.mobile} {
      max-width: 126px;
      select {
        padding: 0 20px 0 6px;
      }

      .search-filter-icon {
        right: 6px;
      }
    }
  }
`

export const Logo = styled.div`
  transform: translateY(2px);
`

export const SiteButton = styled.button`
  appearance: none;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  padding: 8px;
  margin-left: -8px;
`

export const Wrap = styled.div`
  position: relative;
  max-width: 1600px;
  height: ${(props) => props.menuHeight}px;

  ${media.mobile} {
    height: 48px;
  }
`
